import fflip from "fflip";

import criteria, { CriteriaType } from "./criteria";

// Add and remove from this type as features are added/removed
// eg: type FeatureType = "a" | "b" | "c"
export type FeatureType = "enableSocialShare";

type Criteria = {
  [K in CriteriaType]?: boolean;
};

interface FeatureObject {
  id: FeatureType;
  criteria: Criteria | Criteria[];
}

const features: FeatureObject[] = [
  {
    id: "enableSocialShare",
    criteria: { "env:production": true },
  },
];

fflip.config({
  criteria,
  features,
});

export const isEnabled = (feature: FeatureType): boolean => {
  return fflip.isFeatureEnabledForUser(feature, {});
};

export default isEnabled;
